import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    { class: { "filters-loading": _setup.filtersStore.isLoading } },
    [
      _c(_setup.ChipsFilters),
      _vm._v(" "),
      _c(_setup.CityFilters),
      _vm._v(" "),
      _c(_setup.DateFilters),
      _vm._v(" "),
      _c(_setup.PlaceFilters),
      _vm._v(" "),
      _c(_setup.PriceFilters),
      _vm._v(" "),
      _c(_setup.ExperienceFilters),
      _vm._v(" "),
      _c(_setup.GenderFilters),
      _vm._v(" "),
      _c(_setup.CategoryFilters),
      _vm._v(" "),
      _c(_setup.ScienceFilters),
      _vm._v(" "),
      _c(_setup.PatientAgeFilters),
      _vm._v(" "),
      _c(_setup.HighRatingFilters),
      _vm._v(" "),
      _c(_setup.OtherSpecialityFilters),
      _vm._v(" "),
      _c(_setup.DiseaseFilters),
      _vm._v(" "),
      _c(_setup.ClubSwitchFilters),
      _vm._v(" "),
      _c(_setup.VisitLocationFilters),
      _vm._v(" "),
      _c(_setup.AppointmentFilters),
      _vm._v(" "),
      _c(_setup.DoctorFilters),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }